const { isObject } = require('./is-object')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {object} obj
 * @returns {boolean}
 */
function isNotEmptyObject (obj) {
  return (isObject(obj) && Object.keys(obj).length > 0)
}

module.exports = { isNotEmptyObject }
